<mat-form-field (click)="clearFilter()" floatLabel="always">
  <mat-label>Votre compte</mat-label>
  <input type="text" matInput [matAutocomplete]="clients" [formControl]="filterControl" autocomplete="off">
  <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
  <mat-autocomplete #clients='matAutocomplete' [displayWith]="displayFn" (optionSelected)="updateClient($event)"
    (closed)="displaySelected()">
    <ng-container *ngIf="filteredClients | async as listClients">
      <mat-option *ngIf="loadingClients" disabled>
        <mat-spinner diameter="20"></mat-spinner>
      </mat-option>
      <ng-container *ngIf="!loadingClients">
        <mat-option *ngFor="let client of listClients" [value]="client">
          {{ displayFn(client) }}
        </mat-option>
        <mat-option *ngIf="listClients.length === 0" disabled>
          Aucun résultat
        </mat-option>
      </ng-container>
    </ng-container>
  </mat-autocomplete>
</mat-form-field>